export function availableLocales(locales: any) {
  for (const locale of locales) {
    switch (locale.code) {
      case 'en':
        locale.flagCode = 'us';
        locale.displayText = 'EN';
        break;
      case 'ko':
        locale.flagCode = 'kr';
        locale.displayText = 'KR';
        break;
      case 'ja':
        locale.flagCode = 'jp';
        locale.displayText = 'JP';
        break;
      case 'zh':
        locale.flagCode = 'cn';
        locale.displayText = 'CH';
        break;
    }
  }

  return locales;
}

export function getCurrentLocale(localeInfo: {
  localeCookie: string | undefined;
  browserLocale: string | undefined;
  locales: any;
}) {
  const { localeCookie, browserLocale, locales } = localeInfo;
  if (localeCookie) {
    for (const locale of availableLocales(locales)) {
      if (locale.code === localeCookie) {
        return locale;
      }
    }
  }

  if (browserLocale) {
    for (const locale of availableLocales(locales)) {
      if (locale.code === browserLocale) {
        return locale;
      }
    }
  }

  return {
    code: 'en',
    flagCode: 'us',
    file: 'en_US.json',
    name: 'English',
    displayText: 'EN',
  };
}
